
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"24.Tractor"}},[_c('path',{attrs:{"d":"M14 34a3 3 0 11-3.9-2.86A3 3 0 0114 34z"}}),_c('path',{attrs:{"d":"M11 24a10 10 0 109.16 14A10 10 0 0011 24zm4.58 12A5 5 0 1111 29a5 5 0 014.58 7zM41 32a6 6 0 106 6 6 6 0 00-6-6zm0 8a2 2 0 112-2 2 2 0 01-2 2zM8 12h3v6H8zM27.54 18H17v-6h9.15l1.39 6z"}}),_c('path',{attrs:{"d":"M46 30a2 2 0 01-1.41-3.41C45.26 25.9 46 26 47 26a4 4 0 00-3.35-3.53C24.93 19.52 31.35 20 16 20a1 1 0 01-1-1v-7h-2v7a1 1 0 01-1 1H8v2.49A11.91 11.91 0 0122.21 38H33a8 8 0 0114-5.28V30zm-14 3h-4a1 1 0 010-2h4a1 1 0 010 2zm0-4h-4a1 1 0 010-2h4a1 1 0 010 2zm0-4h-4a1 1 0 010-2h4a1 1 0 010 2zM29 10H8a2 2 0 010-4h17a4 4 0 014 4zM42 12l-1 4h-2v3.71l-4-.63V16a4 4 0 014-4z"}})])])
          )
        }
      }
    